import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

// constants
import { Radius } from '@styles/Radius';
import { gray } from '@styles/Colors';

const Layout = styled.div`
  display: flex;
  justify-content: center;
`;

const spin = keyframes`
  100%{ -webkit-transform: rotate(360deg); }
`;

const Indicator = styled.div`
  margin: 0 auto;
  width: 32px;
  height: 32px;
  border: 4px solid #fff;
  margin: 0;
  display: block;
  border-radius: ${Radius.MAXIMUM};
  border-color: ${gray.gray6} rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.2);
  animation: ${spin} 1.15s cubic-bezier(0.31, 0.63, 0.8, 0.73) infinite;
`;

export default function LoadingSpinner() {
  return (
    <Layout>
      <Indicator />
    </Layout>
  );
}
